/**
 * 
 * 사이트 Cookie 설정을 쉽게 하기 위해서 함수화
 * 소스에서 불러와 setCookie, getCookie 함수 사용
 * 
 */

import {Cookies} from 'react-cookie';

const cookies = new Cookies();

export const setCookie = (name, value, options) => {
    return cookies.set(name, value, {...options}); 
}

export const getCookie = (name) => {
    return cookies.get(name); 
}